import { useCallback, useEffect, useMemo, useState } from 'react'
import throttle from 'lodash/throttle'
import useAreaOfLaw from 'common/providers/useAreaOfLaw'
import Project from 'common/project'

const SEARCH_DELAY = 500

export const useLawFinder = () => {
  const [lawFinderSearch, setLawFinderSearch] = useState<any>('')
  const [lawFinder, setLawFinder] = useState<any>([])
  const [exampleContents, setExampleContents] = useState<any>([])
  const [examplesContentsLoading, setExampleContentsLoading] = useState(true)
  const { areaOfLaw, getAreaOfLaw } = useAreaOfLaw()

  const throttledSetTitle = useCallback(
    throttle(setLawFinderSearch, SEARCH_DELAY, { leading: true }),
    [],
  )

  useEffect(() => {
    getAreaOfLaw({})
  }, [])

  const updateLawFinderSearchValue = useCallback(
  
    (text: string) => {
      console.log('Updating Law Finder Search Value:', text)
      setLawFinderSearch(text)
      throttledSetTitle(text)
    },
    [throttledSetTitle],
  )

  const onLawFinderFeedback = useCallback(() => {}, [])

  const loadLawFinder = useCallback(async () => {
    if (lawFinderSearch.trim().length >= 5) {
      try {
        const response = await fetch(
          `https://rq2ih15bi6.execute-api.eu-west-2.amazonaws.com/prod/predict/top3`,
          {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ 'query': lawFinderSearch }),
          },
        )

        if (!response.ok) {
          throw new Error(`HTTPS error! status: ${response.status}`)
        }

        const result = await response.json()
        console.log('Law Finder Result:', result)

        const areas: { area_of_law: string }[] = result.top_predictions.map((item) => ({
          area_of_law: item.area_of_law,
        }));

        console.log('Areas of Law Classified:', areas)
        if (areas.length > 0) {
          const matchedAreas = areas.map((classifiedArea) =>
            areaOfLaw.find(
              (area) =>
                area.master_term.toLowerCase() === classifiedArea.area_of_law.toLowerCase()
            )
          )
          // Filter out unmatched areas (null values)
          const validMatchedAreas = matchedAreas.filter((area) => area)
          console.log('Valid Matched Areas:', validMatchedAreas)
          setLawFinder(validMatchedAreas)
        } else {
          throw new Error('No top3 areas of law found')
         }


      } catch (error) {
        throw new Error('Error fetching law finder data:', error)
      }
    }
  }, [lawFinderSearch])

  const getExampleContents = useCallback(() => {
    fetch(`${Project.liveApi}find-a-lawyers/example-contents`,
    )
      .then((response) => response.json())
      .then((data) => {
        const formattedTabs = (data as { content: string }[]).map(
          (item, index) => ({
            id: index + 1,
            title: `Example ${index + 1}`,
            content: item.content,
          }),
        )
        setExampleContents(formattedTabs)
      })
      .then(() => setExampleContentsLoading(false))
  }, [])

  const results = useMemo(() => {
    return lawFinder ?? null
  }, [lawFinder])

  return {
    loadLawFinder,
    getExampleContents,
    lawFinder: results,
    exampleContents,
    updateLawFinderSearchValue,
    lawFinderSearch,
    onLawFinderFeedback,
    examplesContentsLoading,
  }
}
